import {mapGetters} from 'vuex';
export default {
    computed:{
        ...mapGetters(['couponData']),
        productPrice(){
            return (this.product.price * this.order.details.quantity);
        },
        packaging(){
            if(this.product.use_fixed_packaging_price){
                return (this.packaging_fee * this.order.details.quantity);
            }else{
                return (this.selectionsPackagingFeeTotal + this.extraSelectionsPackagingFeeTotal) * this.order.details.quantity;
            }
        },
        energy(){
            if(this.energy_fee === null){
                return 0;
            }

            return (this.energy_fee * this.order.details.quantity);
        },
        premiumSelectionsPrice(){
            let selectedOptions = _.flatten(this.order.details.selections.map(item =>{
                return item.options.map(optionItem => {
                    return {
                        selection_id: item.selection_id,
                        option_id: optionItem,
                    }
                })
            })).map(item => {
                const selection = this.product.selections.find(selectionItem => selectionItem.id === item.selection_id);
                const option = selection.options.find(optionItem => optionItem.id === item.option_id);
                return option;
            }).filter(item => {
                return item.premium;
            }).map(item => {
                return item.price;
            });

            if(selectedOptions.length === 0){
                return 0;
            }

            return selectedOptions.reduce((accumulator, currentValue) => accumulator + currentValue) * this.order.details.quantity;
        },
        extraSelectionsPrice(){
            let selectedExtraOptions = _.flatten(this.order.details.extra_selections.map(item =>item.options));

            if(selectedExtraOptions.length === 0){
                return 0;
            }

            let extraOptions = _.flatten(this.product.extra_selections.map(item => item.options));
            return extraOptions.filter(item => {
                return selectedExtraOptions.includes(item.id);
            }).map(item => item.as_extra_price).reduce((accumulator, currentValue) => accumulator + currentValue) * this.order.details.quantity;
        },
        selectionsPackagingFeeTotal(){
            let selectedOptions = _.flatten(this.order.details.selections.map(item =>{
                return item.options.map(optionItem => {
                    return {
                        selection_id: item.selection_id,
                        option_id: optionItem,
                    }
                })
            })).map(item => {
                const selection = this.product.selections.find(selectionItem => selectionItem.id === item.selection_id);
                const option = selection.options.find(optionItem => optionItem.id === item.option_id);
                return option;
            }).map(item => {
                return item.packaging_price;
            });

            if(selectedOptions.length === 0){
                return 0;
            }

            return selectedOptions.reduce((accumulator, currentValue) => accumulator + currentValue);
        },
        extraSelectionsPackagingFeeTotal(){
            let selectedExtraOptions = _.flatten(this.order.details.extra_selections.map(item =>item.options));

            if(selectedExtraOptions.length === 0){
                return 0;
            }

            let extraOptions = _.flatten(this.product.extra_selections.map(item => item.options));
            return extraOptions.filter(item => {
                return selectedExtraOptions.includes(item.id);
            }).map(item => item.packaging_price).reduce((accumulator, currentValue) => accumulator + currentValue);
        },
        total(){
            let total = this.productPrice + this.packaging + this.energy + this.premiumSelectionsPrice + this.extraSelectionsPrice;

            if(this.order.delivery.delivery_fee > 0){
                total += this.order.delivery.delivery_fee;
            }

            return total;
        },
        totalWithoutDeliveryFee(){
            return this.productPrice + this.packaging + this.energy + this.premiumSelectionsPrice + this.extraSelectionsPrice;
        },
        totalWithoutPackaging() {
            if(this.order.delivery.delivery_fee > 0){
                return this.productPrice + this.premiumSelectionsPrice + this.extraSelectionsPrice + this.order.delivery.delivery_fee;
            }
            return this.productPrice + this.premiumSelectionsPrice + this.extraSelectionsPrice;
        },
        discount(){
            return {
                productPrice: this.calculateDiscount(this.productPrice),
                packaging: this.calculateDiscount(this.packaging),
                energy: this.calculateDiscount(this.energy),
                premiumSelectionsPrice: this.calculateDiscount(this.premiumSelectionsPrice),
                extraSelectionsPrice: this.calculateDiscount(this.extraSelectionsPrice),
                totalWithoutDeliveryFee: this.calculateDiscount(this.totalWithoutDeliveryFee, true),
                total: (this.totalWithoutDeliveryFee - this.calculateDiscount(this.totalWithoutDeliveryFee)) + this.order.delivery.delivery_fee,
                text: this.createDiscountText(),
            }
        }
    },
    methods:{
        selectionHasPremiumSelected(selection){
            return selection.options.filter(item => item.premium).length > 0;
        },
        selectionSelectedPremiumOptionsTotal(selection){
            return selection.options.filter(item => item.premium).map(item => item.price).reduce((acc, cur) => acc + cur);
        },
        selectionSelectedExtraOptionsTotal(selection){
            return selection.options.map(item => item.as_extra_price * this.order.details.quantity).reduce((acc, cur) => acc + cur);
        },
        calculateDiscount(amount, useDifference){
            if(!this.couponData){
                return 0;
            }

            if(this.couponData.in_percent){
                const percentage = this.couponData.value / 100;
                return amount * percentage;
            }


            const discount = amount - this.couponData.value;

            if(discount < 0){
                return amount;
            }

            return amount - discount;
        },
        createDiscountText(){
            if(!this.couponData){
                return;
            }

            if(this.couponData.in_percent){
               return `${this.couponData.value}%`;
            }

            return this.couponData.value;
        }
    }
}
